import './contact.css'
import {IoMail} from 'react-icons/io5'
import { FaGithub, FaLinkedin } from 'react-icons/fa'

function Contact() {
  return (
    <section id="contact">
      <h1 className='section-header'>Let's Connect</h1>
      <div className='contact-content'>
        <div className='contact-list'>
          <a href='https://www.linkedin.com/in/ericanwoga/' target="_blank" rel="noopener noreferrer"><FaLinkedin className='linkedin-icon'/></a>
          <a href="mailto:nwoga.erica@gmail.com" target="_blank" rel="noopener noreferrer"><IoMail className='email-icon'/></a>
          <a href="https://github.com/ericanwoga" target="_blank" rel="noopener noreferrer"><FaGithub className='github-icon'/></a>
        </div>
      </div> 
    </section>
  )
}

export default Contact
